<template>
  <div class="rating-view">
    <div class="header"><span class="mb-0">評価詳細確認</span></div>
    <template v-if="isLoading">
      <AppLoading/>
    </template>
    <template v-else>
      <div class="wrap-rating-view">
        <div class="d-flex justify-content-between rating-statistical">
          <div class="d-flex rating-statistical-item">
            <div>
              <img src="@/assets/images/icon_good.svg"/>
            </div>
            <div class="pl-3 content-rating">
              <div class="title-item">評価総数</div>
              <div class="item-value">{{ data?.totalEvaluations }}</div>
            </div>
          </div>
          <div class="d-flex rating-statistical-item">
            <div>
              <img src="@/assets/images/ic-sunny.svg"/>
            </div>
            <div class="pl-3 content-rating">
              <div class="title-item">もう1度取引を望む</div>
              <div class="item-value">{{ data?.goodReviews }}%</div>
            </div>
          </div>
          <div class="d-flex rating-statistical-item">
            <div>
              <img src="@/assets/images/ic-rain.svg"/>
            </div>
            <div class="pl-3 content-rating">
              <div class="title-item">何らかの理由で未成立</div>
              <div class="item-value">{{ data?.badReviews }}%</div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between rating-statistical">
          <div class="d-flex rating-statistical-item">
            <div>
              <img src="@/assets/images/ic-money-back.svg"/>
            </div>
            <div class="pl-3 content-rating">
              <div class="title-item">取引成立総数</div>
              <div class="item-value">{{ data?.countEstateBidding }}</div>
            </div>
          </div>
          <div class="d-flex rating-statistical-item">
            <div>
              <img src="@/assets/images/icon_bad.svg"/>
            </div>
            <div class="pl-3 content-rating">
              <div class="title-item">落札取消総数</div>
              <div class="item-value">{{ data?.countDeleteWonBid }}</div>
            </div>
          </div>
          <div class="d-flex rating-statistical-item-none"/>
        </div>
        <div class="table-evaluation">
          <div class="row wrap-title-table-evaluation">
            <div class="col-md-3"></div>
            <div class="col-md-3 title-table-evaluation">出品時の評価</div>
            <div class="col-md-3 title-table-evaluation">落札時の評価</div>
            <div class="col-md-3 title-table-evaluation">評価合計</div>
          </div>
          <div class="row wrap-content-table-evaluation show-on-pc">
            <div class="col-md-3 d-flex wrap-item-evaluation">
              <img class="img-evaluation" src="@/assets/images/ic-sunny.svg"/>
              <div class="pl-2 font-weight-bold">もう1度取引を望む</div>
            </div>
            <div class="col-md-3 wrap-item-evaluation">
              <span>{{ data?.countGoodSeller }}</span>
              <span class="item-rating-evaluation"
              >({{ data?.goodSellerReviews }}%)</span
              >
            </div>
            <div class="col-md-3 wrap-item-evaluation">
              <span>{{ data?.countGoodBidder }}</span>
              <span class="item-rating-evaluation"
              >({{ data?.goodBidderReviews }}%)</span
              >
            </div>
            <div class="col-md-3 wrap-item-evaluation">
              <span>{{ data?.good }}</span>
              <span class="item-rating-evaluation"
              >({{ data?.goodReviews }}%)</span
              >
            </div>
          </div>
          <div class="row wrap-content-table-evaluation show-on-pc">
            <div class="col-md-3 d-flex wrap-item-evaluation">
              <img class="img-evaluation" src="@/assets/images/ic-rain.svg"/>
              <div class="pl-2 font-weight-bold">何らかの理由で未成立</div>
            </div>
            <div class="col-md-3 wrap-item-evaluation">
              <span>{{ data?.countBadSeller }}</span>
              <span class="item-rating-evaluation"
              >({{ data?.badSellerReviews }}%)</span
              >
            </div>
            <div class="col-md-3 wrap-item-evaluation">
              <span>{{ data?.countBadBidder }}</span>
              <span class="item-rating-evaluation"
              >({{ data?.badBidderReviews }}%)</span
              >
            </div>
            <div class="col-md-3 wrap-item-evaluation">
              <span>{{ data?.bad }}</span>
              <span class="item-rating-evaluation"
              >({{ data?.badReviews }}%)</span
              >
            </div>
          </div>
          <BoxStatus
            :class-name="'hide-on-pc'"
            :title-box="'もう1度取引を望む'"
            :icon-url="'sunny'">
            <div class="row wrap-content-table-evaluation">
              <div class="col-md-3 wrap-item-evaluation">
                <div class="left-item">
                  <span>出品時の評価</span>
                </div>
                <div class="right-item">
                  <span>{{ data?.countGoodSeller }}</span>&nbsp;
                  <span class="item-rating-evaluation">({{ data?.goodSellerReviews }}%)</span>
                </div>
              </div>
              <div class="col-md-3 wrap-item-evaluation">
                <div class="left-item">
                  <span>落札時の評価</span>
                </div>
                <div class="right-item">
                  <span>{{ data?.countGoodBidder }}</span>&nbsp;
                  <span class="item-rating-evaluation">({{ data?.goodBidderReviews }}%)</span>
                </div>
              </div>
              <div class="col-md-3 wrap-item-evaluation">
                <div class="left-item">
                  <span>評価合計</span>
                </div>
                <div class="right-item">
                  <span>{{ data?.good }}</span>&nbsp;
                  <span class="item-rating-evaluation">({{ data?.goodReviews }}%)</span>
                </div>
              </div>
            </div>
          </BoxStatus>
          <BoxStatus
            :class-name="'hide-on-pc'"
            :title-box="'何らかの理由で未成立'"
            :icon-url="'rain'">
            <div class="row wrap-content-table-evaluation">
              <div class="col-md-3 wrap-item-evaluation">
                <div class="left-item">
                  <span>出品時の評価</span>
                </div>
                <div class="right-item">
                  <span>{{ data?.countBadSeller }}</span>&nbsp;
                  <span class="item-rating-evaluation">({{ data?.badSellerReviews }}%)</span>
                </div>
              </div>
              <div class="col-md-3 wrap-item-evaluation">
                <div class="left-item">
                  <span>落札時の評価</span>
                </div>
                <div class="right-item">
                  <span>{{ data?.countBadBidder }}</span>&nbsp;
                  <span class="item-rating-evaluation">({{ data?.badBidderReviews }}%)</span>
                </div>
              </div>
              <div class="col-md-3 wrap-item-evaluation">
                <div class="left-item">
                  <span>評価合計</span>
                </div>
                <div class="right-item">
                  <span>{{ data?.bad }}</span>&nbsp;
                  <span class="item-rating-evaluation">({{ data?.badReviews }}%)</span>
                </div>
              </div>
            </div>
          </BoxStatus>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import AppLoading from '@/components/Loading/AppLoading.vue';
import { mapGetters } from 'vuex';
import BoxStatus from '@/components/RatingDetail/BoxStatus.vue';

export default {
  name: 'RatingView',
  data() {
    return {
      data: [],
      isLoading: true,
    };
  },
  components: {
    AppLoading,
    BoxStatus,
  },
  computed: {
    ...mapGetters({
      ratingDetail: 'rating-detail/dataRating',
    }),
  },
  async created() {
    await this.getData();
    this.isLoading = false;
  },
  watch: {
    ratingDetail() {
      if (this.ratingDetail) {
        this.data = this.ratingDetail;
      }
    },
  },
  methods: {
    async getData() {
      return this.$store.dispatch('rating-detail/getRatingDetail', '');
    },
  },
};
</script>
